import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ManageStudents from './ManageStudents';
import {deleteUserConnection} from 'src/redux/userConnections/actions';
import {deletePotentialConnectedUser} from 'src/redux/potentialConnectedUsers/actions';

const mapStateToProps = ({loading, potentialConnectedUsers, userConnections}) => ({
  potentialConnectedUsers,
  userConnections,
  loading,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deleteUserConnection,
      deletePotentialConnectedUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ManageStudents);
